import { useEffect, useCallback } from 'react';

import toast from 'react-hot-toast';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import styles from './Login.module.css';
import LoginForm from '../../components/Forms/Signup/LoginForm';
import SocialButton from '../../components/UI/Buttons/SocialButton/SocialButton';
import { userVerifyEmail } from '../../services/userService';
import { useGetQueryParam } from '../../utils/utilityHooks';
import { fetchUserByToken } from '../../app/features/userSlice';
import { HeroSectionBottomRightRock, HeroSectionLeftRock, HeroSectionTopRightRock } from '../../assets/images/icons';

function Login() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const emailToken = useGetQueryParam('token');
    const userData = useSelector((state) => state.user.userData);

    const verifyEmailToken = useCallback((emailToken) => {
        toast.promise(userVerifyEmail(false, emailToken), {
            loading: t('general.UI.loading'),
            success: t('general.UI.success'),
            error: t('general.UI.something_went_wrong'),
        })
            .then((data) => {
                if (data?.token) {
                    dispatch(fetchUserByToken(data.token));
                }
            })
            .catch((error) => { toast.error(error.error); });
    }, [dispatch, t]);

    useEffect(() => {
        if (emailToken) { verifyEmailToken(emailToken); }
    }, [verifyEmailToken, emailToken]);
    const navigate = useNavigate();

    return (
        <>
            <Helmet>
                <title>FindCV - Login</title>
            </Helmet>
            <div className={styles.entityWrapper} style={{ height: "auto" }}>
                <div className={styles.backgroundLayer}></div>
                <img src={HeroSectionLeftRock} className={styles.HeroSectionCircle1} alt="Decorative rock on the left in the Hero section" />
                <img src={HeroSectionTopRightRock} className={styles.HeroSectionCircle2} alt="Decorative rock on the top-right in the Hero section" />
                <img src={HeroSectionBottomRightRock} className={styles.HeroSectionCircle3} alt="Decorative rock on the bottom-right in the Hero section" />
                <div className={styles.formContainer}>
                    <p className={`${styles.entityHeading} ${styles.entityTitle}`}>{t('login.heading')}</p>
                    <LoginForm className={styles.form} />
                    {!userData && (
                        <>
                            <div className={styles.divider}>
                                <div className={styles.dividerLine}></div>
                                <div className={styles.orText}>{t('login.orLoginWith')}</div>
                                <div className={styles.dividerLine}></div>
                            </div>
                            <SocialButton isRegister />
                        </>
                    )}
                    <p className={styles.signupText}>
                        {t('login.noAccount')}
                        <span
                            onClick={() => navigate('/create-account')}
                            className={styles.loginLink}>
                            {t('login.clickHere')}
                        </span>
                        {t('login.toSignup')}
                    </p>
                </div>
            </div>
        </>
    );
}

export default Login;